import { render, staticRenderFns } from "./ResultApi.vue?vue&type=template&id=e59c102a&"
import script from "./ResultApi.vue?vue&type=script&lang=js&"
export * from "./ResultApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports